module.exports = __webpack_public_path__ + "img/partner-icon.6c55fba6.svg";